import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { Router, Route, hashHistory } from 'react-router';
// import createBrowserHistory from 'history/lib/createBrowserHistory'
// const history = createBrowserHistory();

var ReactGA = require('react-ga');
ReactGA.initialize('UA-94113807-1');

function logPageView() {
  ReactGA.set({ page: window.location.pathname });
  ReactGA.pageview(window.location.pathname);
}




import PortfolioPage from './components/Portfolio';
import ServicesPage from './components/Services';
import AboutPage from './components/About';
import Home from './components/Home';
import CVPage from './components/CV';
import error404 from './components/404.js';
ReactDOM.render(
  <Router history={hashHistory} onUpdate={logPageView}>
    <Route name="app" path="/" component={App}>
      <Route path="home" component={Home} />
      <Route path="services" component={ServicesPage} />
      <Route path="about" component={AboutPage} />
      <Route path="portfolio" component={PortfolioPage} />
      <Route path="cv" component={CVPage} />
      <Route path="*" component={error404} />
    </Route>
  </Router>,
  document.getElementById('root')
);

//



// WEBPACK FOOTER //
// ./src/index.js